import { getI18nFromGeneral } from 'src/tools/tools';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { get } from 'lodash';

const checkLoadingAnimation = (image) => {
  const uuid = get(image, 'uuid');
  if (!uuid) {
    return handleError([
      getI18nFromGeneral(`general.moduleListError.${999998}`),
    ]);
  }
};

const checkTopLeaderBoardBanner = () => {
  const checkImg = (image) => {
    // const uuid = get(image, 'uuid');
    // if (!uuid) {
    //   return handleError([
    //     getI18nFromGeneral(`general.moduleListError.${999998}`),
    //   ]);
    // }
    return null;
  };
  const checkLink = (link) => {
    // const linkType = get(link, 'linkType');
    // if (!linkType) {
    //   return handleError([
    //     getI18nFromGeneral(`general.moduleListError.${104316}`),
    //   ]);
    // }
    return null;
  };
  const checkAll = (topLeaderBoardBanner) => {
    const image = get(topLeaderBoardBanner, 'link.linkImage');
    const link = get(topLeaderBoardBanner, 'link');
    const iLink = checkLink(link);
    const iImg = checkImg(image);
    return {
      hasError: get(iImg, 'hasError') || get(iLink, 'hasError'),
    };
  };
  return {
    checkImg,
    checkLink,
    checkAll,
  };
};

const checkAll = (data) => {
  const loadingAnimation = get(data, ['loadingImage']);
  const lR = checkLoadingAnimation(loadingAnimation);
  const topLeaderBoardBanner = get(data, 'topLeaderBoardBanner');
  const { checkAll } = checkTopLeaderBoardBanner();
  return {
    hasError:
      get(checkAll(topLeaderBoardBanner), 'hasError') || get(lR, 'hasError'),
  };
};

export const generateDefaultFloatingActionButtonStyle = () => {
  return {
    customerServiceBackgroundColor: '#000',
    textColor: '#fff',
    backToTopButtonBackgroundColor: '#fff',
    backToTopIconColor: '#000',
  };
};

export const generateDefaultProductDetailsPageTabBarStyle = () => {
  return {
    soldOutFlag: false,
    iconText: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    addToCart: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    buyNow: {
      backgroundColor: '#BC0025',
      textColor: '#ffffff',
      defaultBackgroundColor: '#BC0025',
      defaultTextColor: '#ffffff',
    },
    soldOut: {
      backgroundColor: '##8C9196',
      textColor: '#ffffff',
      defaultBackgroundColor: '##8C9196',
      defaultTextColor: '#ffffff',
    },
    remindMe: {
      backgroundColor: '#5BBD92',
      textColor: '#ffffff',
      defaultBackgroundColor: '#5BBD92',
      defaultTextColor: '#ffffff',
    },
  };
};
export const generateDefaultFlashSaleBarStyle = () => {
  return {
    saleNow: false,
    comingSoonStatus: {
      backgroundColor: '#5BBD92',
      textColor: '#ffffff',
      defaultBackgroundColor: '#5BBD92',
      defaultTextColor: '#ffffff',
    },
    comingSoonPrice: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    saleNowStatus: {
      backgroundColor: '#BC0025',
      textColor: '#ffffff',
      defaultBackgroundColor: '#BC0025',
      defaultTextColor: '#ffffff',
    },
    saleNowPrice: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    salesNowCountDownTimer: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
  };
};

export const generateDefaultPrimaryCallToActionButtonStyle = () => {
  return { backgroundColor: '#000000', textColor: '#ffffff' };
};
export const generateRemainingStockTextStyle = () => {
  return '#000000';
};

export { checkLoadingAnimation, checkTopLeaderBoardBanner, checkAll };
